/**
 * Scene upload pipeline endpoints (T025). The full client flow (read → hash →
 * presign → PUT → confirm) is wired in useUpload (T038); these are the wire
 * calls. R2 PUT goes straight to the presigned URL (absolute, no credentials/
 * CSRF), so it bypasses the api client.
 */
import { api } from '../http'
import { ApiError } from '../errors'
import {
  ScenePresignResponseSchema,
  JobMutationResponseSchema,
} from '../schemas'

export interface PresignSceneBody {
  filename: string
  archive_size: number
  archive_hash: string
  manifest: unknown
}

export const presignScene = (jobId: string, body: PresignSceneBody) =>
  api.post(`/jobs/${jobId}/scene/presign`, body, ScenePresignResponseSchema)

export const confirmScene = (
  jobId: string,
  archive_hash: string,
  archive_size: number,
) =>
  api.post(
    `/jobs/${jobId}/scene/confirm`,
    { archive_hash, archive_size },
    JobMutationResponseSchema,
  )

/** Upload bytes to a presigned R2 URL. Content-Type defaults to zstd (C5). */
export async function uploadToR2(
  presignedUrl: string,
  data: BodyInit,
  contentType = 'application/zstd',
): Promise<void> {
  let resp: Response
  try {
    resp = await fetch(presignedUrl, {
      method: 'PUT',
      mode: 'cors',
      headers: { 'Content-Type': contentType },
      body: data,
    })
  } catch {
    throw new ApiError('Unknown', 'Nie udalo sie wyslac sceny do magazynu', 0)
  }
  if (!resp.ok) {
    throw new ApiError(
      'Unknown',
      `Wysylanie sceny nie powiodlo sie (kod ${resp.status})`,
      resp.status,
    )
  }
}
